import { render, staticRenderFns } from "./LogoutSSO.vue?vue&type=template&id=02642074"
import script from "./LogoutSSO.vue?vue&type=script&lang=js"
export * from "./LogoutSSO.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports